/**
 * Helpers para el formulario de traspasos
 */

/**
 * Normaliza código de almacén añadiendo padding
 */
export const normalizarAlmacen = (alm) => String(alm ?? "").padStart(2, "0");

/**
 * Obtiene el stock de un producto en un almacén específico
 */
export const getStockEnAlmacen = (producto, almacen) => {
    const a = normalizarAlmacen(almacen);
    const row = producto?.Stocks2Models?.find((s) => normalizarAlmacen(s.ALMACEN) === a);
    return Number(row?.FINAL ?? 0);
};

/**
 * Obtiene el código de barras principal de un producto
 */
export const getBarcode = (producto) => producto?.BarrasModels?.[0]?.BARRAS ?? "";

/**
 * Obtiene todos los códigos de barras de un producto
 */
export const getAllBarcodes = (producto) =>
    producto?.BarrasModels?.map((b) => b.BARRAS).filter(Boolean) ?? [];

/**
 * Valida las líneas del traspaso antes de guardar
 */
export const validarLineas = (lineas) => {
    if (!lineas?.length) {
        return { ok: false, errorMsg: "Añade al menos una línea al traspaso.", lineasNormalizadas: null };
    }

    const lineasNormalizadas = lineas.map((l) => ({
        ...l,
        unidades: Number(l.unidadesInput ?? l.unidades ?? 0),
    }));

    for (const l of lineasNormalizadas) {
        const u = Number(l.unidades);

        if (!Number.isFinite(u) || u <= 0) {
            return { ok: false, errorMsg: `La línea ${l.codigo} tiene unidades inválidas.`, lineasNormalizadas: null };
        }

        if (l.stockOrigen != null && u > Number(l.stockOrigen)) {
            return {
                ok: false,
                errorMsg: `La línea ${l.codigo} supera stock de origen (stock: ${l.stockOrigen}).`,
                lineasNormalizadas: null,
            };
        }
    }

    return { ok: true, errorMsg: "", lineasNormalizadas };
};
